import axios from "axios";
export const insertMenus = async (menuData,menuId) => {
  try {
    const response = await axios.post(`http://localhost:8080/webnet-hms/api/menus/create?parentMenuId=${menuId}`, menuData);
    window.alert("Menu inserted successfully:", response.data);
    return response.data;
  } catch (error) {
    window.alert("Error inserting module:", error);
  }
};